import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

/**
 * Compact action button used in list-screen toolbars.
 *   <NtPageActionButton icon="plus" title="Add Extension" onPress={...} />
 */
function NtPageActionButton({
  containerStyle,
  icon,
  onPress,
  title,
  color,
  variant = "secondary", // 'primary' | 'secondary'
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme, variant), [theme, variant]);

  const fg = color || styles.resolvedTextColor;

  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      {icon ? <NtMaterialIcon name={icon} color={fg} size={14} /> : null}
      {title ? (
        <NtText style={[styles.title, { color: fg, marginLeft: icon ? 5 : 0 }]}>
          {title}
        </NtText>
      ) : null}
    </NtTouchableEffect>
  );
}

const makeStyles = (t, variant) => {
  const primary = variant === "primary";
  const bg = primary ? t.brand : t.surface2;
  const bd = primary ? t.brand : t.border;
  const fg = primary ? "#ffffff" : t.text;

  return {
    ...StyleSheet.create({
      container: {
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: t.radius,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        backgroundColor: bg,
        borderWidth: 1,
        borderColor: bd,
      },
      title: { fontSize: 12, fontWeight: "500" },
    }),
    resolvedTextColor: fg,
  };
};

export default NtPageActionButton;
